// extracted by mini-css-extract-plugin
module.exports = {"stats":"statsCard_stats__3Lun-","value":"statsCard_value__1kNbV"};